import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';

// CssBaseline applies MUI's baseline styles globally, including the sans-serif
// font-family on <body> that plain elements like the <h1> title inherit. This
// was previously provided by gatsby-theme-material-ui; it is re-added here after
// that (Gatsby 4-only) plugin was removed.
export const wrapPageElement = ({ element }) => (
  <>
    <CssBaseline />
    {element}
  </>
);
